module.exports = __webpack_public_path__ + "static/media/1.37e6347b.png";